/** A disclosed software author, separate from OMIKINA's fictional personas. */
export interface AiModelAuthor {
  id: string
  displayName: string
  role: string
  modelId: string
  provider: string
  profileUrl: string
  disclosure: string
  shortBio: string
}

export function modelAuthorSchema(author: AiModelAuthor) {
  return {
    '@type': 'SoftwareApplication',
    name: author.displayName,
    identifier: author.modelId,
    applicationCategory: 'Artificial intelligence',
    url: author.profileUrl,
    description: author.disclosure,
    creator: { '@type': 'Organization', name: author.provider },
  }
}
